import { Text } from '@chakra-ui/react';
import { ReactNode } from 'react';

import { ErrorIcon, InfoIcon, SuccessIcon, WarningIcon } from './icons';
import { Alert, AlertProps } from './snippets/Alert';

export function ErrorAlert(props: AlertProps) {
  return <Alert status="error" icon={<ErrorIcon />} {...props} />;
}

export function WarningAlert({ hideIcon, ...props }: AlertProps & { hideIcon?: boolean }) {
  return <Alert status="warning" icon={hideIcon ? undefined : <WarningIcon />} {...props} />;
}

export function SuccessAlert(props: AlertProps) {
  return <Alert status="success" icon={<SuccessIcon />} {...props} />;
}

export function InfoAlert(props: AlertProps) {
  return <Alert status="info" icon={<InfoIcon />} {...props} />;
}

export function TransactionAlert({
  hideInfo,
  showSuccess,
  successMessage,
  infoMessage,
}: {
  hideInfo: boolean;
  showSuccess: boolean;
  successMessage: ReactNode;
  infoMessage: ReactNode;
}) {
  return hideInfo ? (
    showSuccess ? (
      <SuccessAlert>{successMessage}</SuccessAlert>
    ) : null
  ) : (
    <InfoAlert>{infoMessage}</InfoAlert>
  );
}

export function TokenAllowanceAlert({
  hasEnoughAllowance,
  txHash,
  token,
}: {
  hasEnoughAllowance: boolean;
  txHash?: string;
  token: string;
}) {
  return (
    <TransactionAlert
      hideInfo={hasEnoughAllowance}
      showSuccess={txHash !== undefined}
      successMessage={`${token} approved.`}
      infoMessage={<Text>You do not have enough allowance. Approve use of {token}.</Text>}
    />
  );
}
